// Projetos de P&D Strictu Sensu:

// 1. Quais problemas técnicos o projeto visa solucionar com seu desenvolvimento? 
// 1.1 - Houve alguma dificuldade em pensar numa solução técnica para essa resolução?
// 1.2 - Se houve uma dificuldade em pensar essa solução, o conceito utilizado para resolvê-lo é próprio?
// 1.3 - Se o conceito utilizado para resolver os problemas for próprio, existe paralelo no mercado ou na área de conhecimento?

// 2. O que foi desenvolvido para resolver esses problemas? 
// 2.1. Explicar o conceito dessa resolução.
// 2.2 Explicar com maiores detalhes cada etapa referente ao conceito.
// 2.3 Entre as etapas descritas anteriormente, houve alguma etapa de testes para validar a resolução do problema? Se sim, quais? Como foram feitas? 

// 3. Qual(is) o(s) resultado(s) esperado(s) para o desenvolvimento do projeto? Ele resolverá o problema técnico existente hoje? 
// 3.1 Qual(is) o(s) resultado(s) alcançado(s) com o desenvolvimento do projeto até o final do ano anterior?
// 3.2 Qual(is) o(s) próximo(s) passo(s) estão sendo trabalhados neste ano?

// TELA : PARECER FI Group > ALL TYPES (Stricto Sensu)
// a.	Objetivo
// b.	Campo 1: Houve alguma dificuldade em pensar numa solução técnica para essa resolução?
// c.	Campo 2: Se houve uma dificuldade em pensar essa solução, o conceito utilizado para resolvê-lo é próprio? 
// d.	Campo 3: Se o conceito utilizado para resolver os problemas for próprio, existe paralelo no mercado ou na área de conhecimento? 

// b.	Descrição das Atividades
// b.	Campo 1: Explicar o conceito dessa resolução.  
// c.	Campo 2: Explicar com maiores detalhes cada etapa referente ao conceito. 
// d.	Campo 3: Entre as etapas descritas anteriormente, houve alguma etapa de testes para validar a resolução do problema? Se sim, quais? Como foram feitas? 

// c.	Resultados Obtidos
// b.	Campo 1: Qual(is) o(s) resultado(s) esperado(s) para o desenvolvimento do projeto? Ele resolverá o problema técnico existente hoje?   
// c.	Campo 2: Qual(is) o(s) resultado(s) alcançado(s) com o desenvolvimento do projeto até o final do ano anterior? 
// d.	Campo 3: Qual(is) o(s) próximo(s) passo(s) estão sendo trabalhados neste ano? 
export const fieldObjectiveProjectItTics = [
    {
        id: 0, field: 'fieldObjectiveOne', label: 'Houve alguma dificuldade em pensar numa solução técnica para essa resolução?',
        tooltip: (<p style={{ color: "white" }}>A resolução do problema já era conhecida pela empresa? é nova para o time técnico da empresa?; é nova para o mercado?
            Qual foi essa resolução e quais dificuldades para alcançar essa solução no contexto do projeto?</p>)
    },
    {
        id: 1, field: 'fieldObjectiveTwo', label: 'Se houve uma dificuldade em pensar essa solução, o conceito utilizado para resolvê-lo é próprio?',
        tooltip: (<p style={{ color: "white" }}>Caso a solução do problema técnico-científico for interna citar se foi totalmente nova ou já existia anterioremnte. Detalhar as especificidades da aplicação para o âmbito do projeto, para justificar a existência da problemática.</p>)
    },
    {
        id: 2, field: 'fieldObjectiveThree', label: 'Se o conceito utilizado para resolver os problemas for próprio, existe paralelo no mercado ou na área de conhecimento?',
        tooltip: (<p style={{ color: "white" }}>Descrever se a abordagem de resolução do problema é algo que já se tem notícia de ter sido feita no mercado anteriormente. Quanto menos conhecida a problemática frente ao mercado, maior será a classificação do critério C1 na classificação do projeto.</p>)
    },
]
export const fieldDescriptionOfActivitiesProjectItTics = [
    {
        id: 0, field: 'fieldDescriptionOfActivitiesOne', label: 'Explicar o conceito dessa resolução.',
        tooltip: (<p style={{ color: "white" }}>Explicar na teoria os conceitos técnicos abarcados para a resolução e andamento das etapas do projeto.</p>)
    },
    {
        id: 1, field: 'fieldDescriptionOfActivitiesTwo', label: 'Explicar com maiores detalhes cada etapa referente ao conceito.',
        tooltip: (<p style={{ color: "white" }}>Realizar a correlação entre as etapas macro definidas no escopo do ano-base com o contexto do projeto; citar resultados dos estudos; detalhamento dos testes; possíveis erros encontrados; e insights obtidos ao longo do projeto.</p>)
    },
    {
        id: 2, field: 'fieldDescriptionOfActivitiesThree', label: 'Entre as etapas descritas anteriormente, houve alguma etapa de testes para validar a resolução do problema? Se sim, quais? Como foram feitas?',
        tooltip: (<p style={{ color: "white" }}>Evidenciar todas os testes realizados, pois é imprescindível para o critério C3 o detalhamento das testagens realizadas no ano-base.
            <br /><br />
            São as etapas de pesquisa experimental e testes do projeto.A pesquisa experimental é feita para simular os resultados ou validar preliminarmente a estratégia de resolução do desafio, ou do problema ou questão técnica que se quer resolver dentro do seu objetivo ou etapa.Os testes, por sua vez, pretendem validar o funcionamento e desempenho daquilo que foi gerado dentro de toda a condução do projeto. </p>)
    },
]
export const fieldResultsObtainedProjectItTics = [
    {
        id: 0, field: 'fieldResultsObtainedOne', label: 'Qual(is) o(s) resultado(s) alcançado(s) com o desenvolvimento do projeto até o final do ano anterior?',
        tooltip: (<p style={{ color: "white" }}>Descrição dos resultados obtidos até o final do ano-base anterior ao projeto, para justificar o andamento e as etapas que estão sendo justificadas.</p>)
    },
    {
        id: 1, field: 'fieldResultsObtainedTwo', label: 'Qual(is) o(s) próximo(s) passo(s) estão sendo trabalhados neste ano?',
        tooltip: (<p style={{ color: "white" }}>Para os projetos é imprescindível detalhar o escopo futuro de etapas e a data prevista de término, para ser possível vincular o projeto no próximo ano como plurianual</p>)
    },
]

// TELA : PARECER FI Group > ALL TYPES (Stricto Sensu)
// a.	Objetivo
// a.	Subtítulo: Quais problemas técnicos o projeto visa solucionar com seu desenvolvimento?

// b.	Descrição das Atividades
// a.	Subtítulo: O que foi desenvolvido para resolver esse problema?

// c.	Resultados Obtidos
// a.	Subtítulo: O que foi desenvolvido para resolver esse problema?
export const fieldsAllTypes = [
    {
        id: 0, title: 'Objetivo', subTitle: 'Quais problemas técnicos o projeto visa solucionar com seu desenvolvimento?', list: fieldObjectiveProjectItTics,
        tooltip: (<p style={{ color: "white" }}>Detalhar quais problemas foram mapeados na idealização inicial do projeto, ou qual barreira de expansão técnica o projeto busca romper. Como exemplo, atuar com uma nova linha de voltagem X que não era de conhecimento da empresa</p>)
    },
    {
        id: 1, title: 'Descrição das Atividades', subTitle: 'O que foi desenvolvido para resolver esses problemas?', list: fieldDescriptionOfActivitiesProjectItTics,
        tooltip: (<p style={{ color: "white" }}>Quais foram as etapas executadas pelo corpo técnico para resolução do problema técnico-científico?</p>)
    },
    {
        id: 2, title: 'Resultados Obtidos', subTitle: 'Qual(is) o(s) resultado(s) esperado(s) para o desenvolvimento do projeto? Ele resolverá o problema técnico existente hoje?', list: fieldResultsObtainedProjectItTics,
        tooltip: (<p style={{ color: "white" }}>Item principal para análise do Critério C1. Problema cuja solução requer a aplicação de conhecimentos e práticas baseados em princípios científicos. Indicar se o problema é de conhecimento da empresa/mercado, e quais processos seguirá para resolução.
            <br /><br />
            É o resultado esperado do projeto, ou alcançado com este ao seu final. Ele pode ser expresso em termos de evolução de um produto ou processo já existente, ou de novas funcionalidades que possibilitam criar  demandas adicionais de finalidade por estes.</p>)
    },
]

// Formação e Capacitação Profissional

// 1. Qual(is) o(s) curso(s) será(ão) ministrado(s)? Com qual(is) finalidade(s)? 
// 1.1. Descreva com detalhes os módulos do(s) curso(s).
// 1.2  Qual o período total desse(s) curso(s)? (Descrever se será em caráter contínuo e por quantos anos).
// 1.3 Quais módulos foram efetivamente ministrados no ano anterior? Por quanto tempo?

// 2. Qual o nível mínimo de escolaridade requerido pelos alunos que estão matriculados no(s) curso(s)?
// 2.1 Quais conhecimentos são considerados pré-requisitos para que a(o) aluna(o) consiga progredir no(s) curso(s)?

// 3. Quantos alunos foram matriculados no ano anterior? 
// 3.1 Houve conclusão do curso pelos alunos no ano anterior?
// 3.2 Esses alunos são funcionários da empresa beneficiária?

// TELA : PARECER FI Group > ALL TYPES (Formação e Capacitação Profissional)
// a.	Objetivo
// b.	Campo 1: Descreva com detalhes os módulos do(s) curso(s).   
// c.	Campo 2: Qual o período total desse(s) curso(s)? (Descrever se será em caráter contínuo e por quantos anos). 
// d.	Campo 3: Quais módulos foram efetivamente ministrados no ano anterior? Por quanto tempo? 

// b.	Descrição das Atividades
// b.	Campo 1: Quais conhecimentos são considerados pré-requisitos para que a(o) aluna(o) consiga progredir no(s) curso(s)?    

// c.	Resultados Obtidos
// b.	Campo 1: Houve conclusão do curso pelos alunos no ano anterior?  
// c.	Campo 2: Esses alunos são funcionários da empresa beneficiária? 
export const fieldObjective = [
    {
        id: 0, field: 'fieldObjectiveOne', label: 'Descreva com detalhes os módulos do(s) curso(s).',
        tooltip: (<p style={{ color: "white" }}>Neste ponto, deve-se descrever quais os conhecimentos serão ministrados em cada módulo, dentro do contexto do curso.</p>)
    },
    {
        id: 1, field: 'fieldObjectiveTwo', label: 'Qual o período total desse(s) curso(s)? (Descrever se será em caráter contínuo e por quantos anos).',
        tooltip: (<p style={{ color: "white" }}>Colocar desde o início de sua concepção até a expectativa de finalização da disponibilização desse curso. O contexto aqui diz respeito a tudo o que envolve o curso, incluindo o processo de gestão e estruturação deste. Em alguns casos, poderá não haver uma expectativa de finalização.</p>)
    },
    {
        id: 2, field: 'fieldObjectiveThree', label: 'Quais módulos foram efetivamente ministrados no ano anterior? Por quanto tempo?',
        tooltip: (<p style={{ color: "white" }}>Se for um curso de duração finita dentro de um ano ou semestre que se repita continuamente, deixar indicado neste campo a qual ano-base se refere e o período de duração no formato (XX/202X a XX/202X).</p>)
    },
]
export const fieldDescriptionOfActivities = [
    {
        id: 0, field: 'fieldDescriptionOfActivitiesOne', label: 'Quais conhecimentos são considerados pré-requisitos para que a(o) aluna(o) consiga progredir no(s) curso(s)?',
        tooltip: (<p style={{ color: "white" }}>Descrever o conjunto de conhecimentos de pré-requisito necessários para se matricular no curso.</p>)
    },
]
export const fieldResultsObtained = [
    {
        id: 0, field: 'fieldResultsObtainedOne', label: 'Houve conclusão do curso pelos alunos no ano anterior?',
        tooltip: (<p style={{ color: "white" }}>Se sim, descrever quantos alunos concluíram o curso e se obtiveram ou não um certificado de conclusão.</p>)
    },
    {
        id: 1, field: 'fieldResultsObtainedTwo', label: 'Esses alunos são funcionários da empresa beneficiária?',
        tooltip: (<p style={{ color: "white" }}>Caso não sejam, contextualizar a participação deles no curso, como egressos do Ensino médio profissionalizante, por exemplo.</p>)
    },
]

// TELA : PARECER FI Group > ALL TYPES (Formação e Capacitação Profissional)
// a.	Objetivo
// a.	Subtítulo: Qual(is) curso(s) será(ão) ministrado(s)? Com qual(is) finalidade(s)?

// b.	Descrição das Atividades
// a.	Subtítulo: Qual o nível mínimo de escolaridade requerido pelos alunos que estão matrículados no(s) curso(s)?

// c.	Resultados Obtidos
// a.	Subtítulo: Qual(is) o(s) resultado(s) esperado(s) para o desenvolvimento do projeto? Ele resolverá o problema técnico existente hoje?
export const fieldsProfessionalTrainingAndQualification = [
    {
        id: 0, title: 'Objetivo', subTitle: 'Qual(is) o(s) curso(s) será(ão) ministrado(s)? Com qual(is) finalidade(s)?', list: fieldObjective,
        tooltip: (<> <p style={{ color: "white" }}>A finalidade neste caso seria mostrar qual a habilidade ou competência adicional que a pessoa terá com o aprendizado do curso. Importante ser relacionado à área de TIC ou automação.</p></>)
    },
    {
        id: 1, title: 'Descrição das Atividades', subTitle: 'Qual o nível mínimo de escolaridade requerido pelos alunos que estão matriculados no(s) curso(s)?', list: fieldDescriptionOfActivities,
        tooltip: (<p style={{ color: "white" }}>Exemplo: Ensino médio, graduação, pós-graduação, etc. </p>)
    },
    {
        id: 2, title: 'Resultados Obtidos', subTitle: 'Quantos alunos foram matriculados no ano anterior?', list: fieldResultsObtained,
        tooltip: (<p style={{ color: "white" }}>Preencher a quantidade númerica.</p>)
    },
]
